import { getDataAsync, postDataAsync, patchDataAsync } from "./PortalApi";
import ContactSalesRequest from "../interfaces/request/ContactSalesRequest";
import ContactSalesUpdateRequest from "../interfaces/request/ContactSalesUpdateRequest";
import ContactSales from "../interfaces/response/ContactSales";

interface ContactSalesPartiallyUpdateRequest {
  op: string;
  path: string;
  value: number;
}

export const getAllContactSalesRequestAsync = async(status?: number) => {
  let routeUrl = "Sales/ContactRequests";

  if (status !== undefined) {
    const statusUrl = `?status=${status}`;
    routeUrl = routeUrl.concat(statusUrl);
  }
  
  const response = await getDataAsync<ContactSales[]>(routeUrl);

  return response;
}

export const contactToSalesAsync = (postData: ContactSalesRequest) => {
  const url = "Sales/ContactRequests";
  return postDataAsync(url, postData);
};

export const partiallyUpdateContactSalesRequestAsync = async (requestId: number, data: ContactSalesUpdateRequest) => {
  const routeUrl = `Sales/ContactRequests/${requestId}`;
  const updateRequest: ContactSalesPartiallyUpdateRequest[] = [{
    op: "replace",
    path: "status",
    value: data.status
  }];

  return await patchDataAsync<ContactSalesPartiallyUpdateRequest[], ContactSales>(routeUrl, updateRequest);
};
